import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../DependencyHelper";
import formStyles from "../../NewLineForms.module.scss";
import DropDown from "../../dropDown/DropDown";

const DeliveryDetailsForm = ({
  variant,
  formName,
  validations,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  readOnlyValues,
  addressTypesOptions,
  stateTypesOptions,
  onChangeHandler,
  containerClassName,
  rowClassName,
  onBlurHandler,
}) => {
  const BUSINESS_ADDRESS_TYPE =
    addressTypesOptions &&
    addressTypesOptions.length > 0 &&
    addressTypesOptions[1]
      ? addressTypesOptions[1].id
      : "";

  const labels = {
    default: {
      unitNo: "Unit no.",
      complexName: "Complex name",
      mobUnitNo: "Unit no. & Complex name",
      optional: " (Optional)",
    },
    business: {
      unitNo: "Unit / Floor no.",
      complexName: "Office park / Building name",
      mobUnitNo: "Unit / Floor no. & Office park / Building name",
      optional: " (Optional)",
    },
  };

  const selectedLables =
    fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE
      ? labels.business
      : labels.default;

  const handleChange = event => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = event => {
    onBlurHandler(event, null, formName);
  }

  const onDropdownChange = (event, val=null, formName) => {
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  }

  return (
    <CustomContainer
      className={`${formStyles[variant]} ${formStyles["main-container"]} ${containerClassName}`}
    >
      <Form.Row className={`${formStyles["main-row"]} ${rowClassName}`}>
        <>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormdl101-${variant}`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormdl101-label-${variant}`}
            >
              Address name
            </Form.Label>
            <Form.Control
              type="text"
              name="addressName"
              value={fieldValues["addressName"]}
              placeholder="Add address name"
              onChange={handleChange}
              readOnly={readOnlyValues["addressName"]}
              isInvalid={fieldErrors["addressName"]}
              className={
                fieldErrors["addressName"] ? formStyles["invalid"] : ""
              }
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["addressName"]}
            </Form.Control.Feedback>
            {!fieldErrors["addressName"] && (
              <div className={formStyles["hint-text"]}>
                {"What you normally call this address (e.g. Home)"}
              </div>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormdl102-${variant}`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormdl102-label-${variant}`}
            >
              Address type
            </Form.Label>
            <DropDown
              formName={formName}
              name="addressType"
              label="Address type"
              data={addressTypesOptions}
              required={true}
              handleSelect={onDropdownChange}
              selectedId={fieldValues["addressType"]}
              customId={`validationFormda102-${variant}`}
              resetRequired={false}
              fieldError={fieldErrors["addressType"]}
            />
          </Form.Group>
        </>
        {fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE && (
          <>
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormdl113-${variant}`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormdl113-label-${variant}`}
              >
                Company name
              </Form.Label>
              <Form.Control
                type="text"
                name="companyName"
                value={fieldValues["companyName"]}
                placeholder="Add company name"
                onChange={handleChange}
                readOnly={readOnlyValues["companyName"]}
                isInvalid={fieldErrors["companyName"]}
                className={
                  fieldErrors["companyName"] ? formStyles["invalid"] : ""
                }
                onBlur={handleBlur}
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["companyName"]}
              </Form.Control.Feedback>
            </Form.Group>
          </>
        )}

        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            xs="12"
            sm="4"
            md="4"
            className={formStyles["form-group"]}
            controlId={`validationFormdl103-${variant}`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormdl103-label-${variant}`}
            >
              {selectedLables.unitNo}
              {!validations["unitNo"] && <span>{selectedLables.optional}</span>}
            </Form.Label>
            <Form.Control
              type="text"
              name="unitNo"
              value={fieldValues["unitNo"]}
              placeholder="#"
              onChange={handleChange}
              readOnly={readOnlyValues["unitNo"]}
              isInvalid={fieldErrors["unitNo"]}
              className={fieldErrors["unitNo"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["unitNo"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            xs="12"
            sm="8"
            md="8"
            className={formStyles["form-group"]}
            controlId={`validationFormdl104-${variant}`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormdl104-label-${variant}`}
            >
              {selectedLables.complexName}
              {!validations["complexName"] && (
                <span>{selectedLables.optional}</span>
              )}
            </Form.Label>
            <Form.Control
              type="text"
              name="complexName"
              value={fieldValues["complexName"]}
              placeholder="Add complex name"
              onChange={handleChange}
              readOnly={readOnlyValues["complexName"]}
              isInvalid={fieldErrors["complexName"]}
              className={
                fieldErrors["complexName"] ? formStyles["invalid"] : ""
              }
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["complexName"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            xs="12"
            sm="4"
            md="4"
            className={formStyles["form-group"]}
            controlId={`validationFormdl105-${variant}`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormdl105-label-${variant}`}
            >
              Street no.
              {!validations["streetNo"] && (
                <span>{selectedLables.optional}</span>
              )}
            </Form.Label>
            <Form.Control
              type="text"
              name="streetNo"
              value={fieldValues["streetNo"]}
              placeholder="#"
              onChange={handleChange}
              readOnly={readOnlyValues["streetNo"]}
              isInvalid={fieldErrors["streetNo"]}
              className={fieldErrors["streetNo"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["streetNo"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            xs="12"
            sm="8"
            md="8"
            className={formStyles["form-group"]}
            controlId={`validationFormdl106-${variant}`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormdl106-label-${variant}`}
            >
              Street name
              {!validations["streetName"] && (
                <span>{selectedLables.optional}</span>
              )}
            </Form.Label>
            <Form.Control
              type="text"
              name="streetName"
              value={fieldValues["streetName"]}
              placeholder="Add street name"
              onChange={handleChange}
              readOnly={readOnlyValues["streetName"]}
              isInvalid={fieldErrors["streetName"]}
              className={fieldErrors["streetName"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["streetName"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            xs="12"
            sm="8"
            md="8"
            className={formStyles["form-group"]}
            controlId={`validationFormdl107-${variant}`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormdl107-label-${variant}`}
            >
              Suburb
            </Form.Label>
            <Form.Control
              type="text"
              name="suburb"
              value={fieldValues["suburb"]}
              placeholder="Add suburb"
              onChange={handleChange}
              readOnly={readOnlyValues["suburb"]}
              isInvalid={fieldErrors["suburb"]}
              className={fieldErrors["suburb"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["suburb"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            xs="12"
            sm="4"
            md="4"
            className={formStyles["form-group"]}
            controlId={`validationFormdl108-${variant}`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormdl108-label-${variant}`}
            >
              Postal code
            </Form.Label>
            <Form.Control
              type="text"
              name="postalCode"
              value={fieldValues["postalCode"]}
              placeholder="#"
              maxLength="4"
              onChange={handleChange}
              readOnly={readOnlyValues["postalCode"]}
              isInvalid={fieldErrors["postalCode"]}
              className={fieldErrors["postalCode"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["postalCode"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormdl109-${variant}`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormdl109-label-${variant}`}
          >
            Town / City
          </Form.Label>
          <Form.Control
            type="text"
            name="town"
            value={fieldValues["town"]}
            placeholder="Add town / city"
            onChange={handleChange}
            readOnly={readOnlyValues["town"]}
            isInvalid={fieldErrors["town"]}
            className={fieldErrors["town"] ? formStyles["invalid"] : ""}
            onBlur={handleBlur}
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["town"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormdl110-${variant}`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormdl110-label-${variant}`}
          >
            Province
          </Form.Label>
          <DropDown
            formName={formName}
            name="province"
            label="Province"
            data={stateTypesOptions}
            required={true}
            handleSelect={onDropdownChange}
            selectedId={fieldValues["province"]}
            customId={`validationFormda110-${variant}`}
            resetRequired={false}
            fieldError={fieldErrors["province"]}
          />
        </Form.Group>

        {variant !== "popup" && (
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={`${formStyles["form-group"]}`}
          >
            <Form.Check
              custom
              name="futureCheck"
              label="Save this address for future purchases"
              checked={fieldValues["futureCheck"]}
              onChange={handleChange}
              className={formStyles["form-checkbox-label"]}
              id={`validationFormdl114-${variant}`}
            />
          </Form.Group>
        )}
      </Form.Row>
    </CustomContainer>
  );
};

DeliveryDetailsForm.propTypes = {
  variant: PropTypes.oneOf(["plain", "popup"]),
  validations: PropTypes.object,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  readOnlyValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  addressTypesOptions: PropTypes.array,
  stateTypesOptions: PropTypes.array,
  containerClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  onBlurHandler: PropTypes.func,
};

DeliveryDetailsForm.defaultProps = {
  variant: "plain",
  validations: {},
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  addressTypesOptions: [],
  stateTypesOptions: [],
};

export default DeliveryDetailsForm;
